import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { ServiceReceipt } from 'types';

export const getServiceReceipt = async ({
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<ServiceReceipt[]> => {
  const serviceId = queryKey[1];
  const { data } = await baseQuery(`job-receipt/${serviceId}`);

  return data;
};
